(function () {
  'use strict';
  if (!/^en(?:-|$)/i.test(document.documentElement.lang || '')) return;
  var script = document.currentScript;
  var dataUrl = script && script.getAttribute('data-translations-url');
  var localeRoot = (script && script.getAttribute('data-locale-root') || '/en').replace(/\/$/, '');
  if (!dataUrl) return;

  var widgetSelector = '.trustoo-widget, #trustoo-review-detail, #tt-carousel-content, #tt-bs-text-container, .tt-card-review, .tt-bs-text, .reviews-text';
  var textSelector = '.trustoo-widget .reviews-text, #trustoo-review-detail .reviews-text, #tt-carousel-content .tt-card-review, #tt-bs-text-container .tt-bs-text, .tt-card-review, .tt-bs-text, .reviews-text';
  var states = new WeakMap();
  var translations = new Map();
  var products = {};
  var loading;
  var ready = false;
  var scheduled = false;

  function normalize(text) {
    // The widget sometimes exposes encoded entities as literal text.
    var result = String(text || '');
    for (var i = 0; i < 2; i += 1) {
      result = result.replace(/&(?:amp|lt|gt|quot|apos|nbsp|#\d+|#x[\da-f]+);/gi, function (entity) {
        var known = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&apos;': "'", '&nbsp;': ' ' };
        if (known[entity.toLowerCase()]) return known[entity.toLowerCase()];
        var number = /^&#x/i.test(entity) ? parseInt(entity.slice(3), 16) : parseInt(entity.slice(2), 10);
        return number > 0 && number <= 0x10ffff ? String.fromCodePoint(number) : entity;
      });
    }
    return result.normalize('NFC').replace(/\s+/g, ' ').trim();
  }

  function translateReview(element) {
    var state = states.get(element);
    var content = element.cloneNode(true);
    // Ignore the app's expand control, but retain the hidden continuation.
    content.querySelectorAll('.display-text').forEach(function (control) { control.remove(); });
    var current = content.textContent;
    if (state && current === (state.originalVisible ? state.original : state.english)) {
      if (!state.controls.isConnected) element.after(state.controls);
      return;
    }
    // The app can reuse a node for a different review after sorting/pagination.
    if (state) { state.controls.remove(); states.delete(element); }
    var english = translations.get(normalize(current));
    if (!english) return; // Untranslated/new reviews stay intact; never guess.

    var controls = document.createElement('div');
    controls.className = 'bk-review-translation';
    controls.bkReviewElement = element;
    controls.setAttribute('translate', 'no');
    controls.style.cssText = 'font-size:12px;margin:6px 0 12px;line-height:1.5';
    var label = document.createElement('span');
    label.textContent = 'English translation · ';
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.textContent = 'Show original';
    toggle.style.cssText = 'font:inherit;color:inherit;background:none;border:0;padding:2px 0;cursor:pointer;text-decoration:underline';
    controls.append(label, toggle);
    state = { original: current, english: english, originalVisible: false, controls: controls };
    states.set(element, state);
    element.textContent = english;
    element.lang = 'en';
    element.after(controls);
    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      state.originalVisible = !state.originalVisible;
      element.textContent = state.originalVisible ? state.original : state.english;
      element.lang = state.originalVisible ? 'lt' : 'en';
      label.textContent = state.originalVisible ? 'Original review · ' : 'English translation · ';
      toggle.textContent = state.originalVisible ? 'Show translation' : 'Show original';
    });
  }

  function update() {
    if (!document.querySelector(widgetSelector)) return;
    if (!ready) {
      if (!loading) {
        loading = fetch(dataUrl, { credentials: 'same-origin' }).then(function (response) {
          if (!response.ok) throw new Error('Review translations unavailable');
          return response.json();
        }).then(function (data) {
          data.translations.forEach(function (entry) { translations.set(normalize(entry.source), entry.en); });
          products = data.products || {};
          ready = true;
          schedule();
        }).catch(function () { /* Leave original reviews visible if the asset cannot load. */ });
      }
      return;
    }
    document.querySelectorAll('.bk-review-translation').forEach(function (control) {
      if (control.bkReviewElement && !control.bkReviewElement.isConnected) control.remove();
    });
    document.querySelectorAll(textSelector).forEach(translateReview);
    document.querySelectorAll('.trustoo-widget a.related-product').forEach(function (link) {
      var source = link.getAttribute('data-bk-product-source') || link.getAttribute('url') || link.getAttribute('href');
      if (!source) return;
      var url;
      try { url = new URL(source, window.location.origin); } catch (_) { return; }
      var product = products[url.pathname];
      if (!product) return;
      if (!link.hasAttribute('data-bk-product-source')) link.setAttribute('data-bk-product-source', source);
      var name = link.querySelector('.product-name');
      if (name && name.textContent !== product.title) name.textContent = product.title;
      var href = localeRoot + '/products/' + product.handle;
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
      if (link.getAttribute('url') !== href) link.setAttribute('url', href);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () { scheduled = false; update(); }, 60);
  }

  function start() {
    update();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
